import apiClient from '../api/client'

const apiHeader = {
  Accept: 'application/json',
  pragma: 'no-cache',
  'cache-control': 'no-cache'
}

export const fetchApi = async (path, data, method, header, signal) => {
  header = { ...apiHeader, ...header }

  const token = localStorage.getItem('token')
  if (token != null) {
    header = { ...header, ...{ Authorization: 'Bearer ' + token } }
  }

  if (!(data instanceof FormData)) {
    header = { ...header, ...{ 'Content-Type': 'application/json' } }
  } else {
    if (header['Content-Type']) {
      delete header['Content-Type']
    }
  }

  try {
    const config = {
      method: method,
      url: path,
      headers: header,
      data: data ? data : null,
      signal: signal
    }

    const response = await apiClient.request(config)
    return response.data
  } catch (error) {

    if (error.success === false && error.errors) {
      throw error 
    }
    
    if (error.response && error.response.data) {
      throw error.response.data
    } else if (error.data) {
      throw error.data
    } else {
      throw { message: error.message || 'Invalid operation' }
    }
  }
}

export const fetchGet = (path, data, header, signal) => {
  header = { ...apiHeader, ...(header || {}) }

  const token = localStorage.getItem('token')
  if (token != null) {
    header = { ...header, ...{ Authorization: 'Bearer ' + token } }
  }

  try {
    const config = {
      method: 'GET',
      url: path,
      headers: header,
      params: data && typeof data === 'object' && !(data instanceof FormData) ? data : undefined,
      signal: signal
    }

    return apiClient.request(config)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          throw error.response.data
        } else {
          throw { message: error.message || 'Invalid operation' }
        }
      })
  } catch (e) {
    return Promise.reject({ message: 'Invalid operation' })
  }
}

export const fetchPost = (path, data, header, signal) => {
  return fetchApi(path, data, 'POST', header, signal)
}

export const fetchPut = (path, data, header, signal) => {
  return fetchApi(path, data, 'PUT', header, signal)
}

export const fetchPatch = (path, data, header, signal) => {
  return fetchApi(path, data, 'PATCH', header, signal)
}

export const fetchDelete = (path, data, header, signal) => {
  return fetchApi(path, data, 'DELETE', header, signal)
}
